import { Package, PackageType } from '@frontend/package/types';

import { isActivePackage } from '../../hooks/useMoveTransaction/move-transaction';

export const findActivePackagesByType = (packages: Package[], type: PackageType): Package[] =>
    packages.filter((pkg) => isActivePackage(pkg) && pkg.type === type);

export const matchesPackageLocation = (pkg: Package, currentSpotId?: string | null, currentSlotId?: string | null): boolean => {
    if (currentSpotId && pkg.spot_id !== currentSpotId) return false;
    if (currentSlotId && pkg.slot_id !== currentSlotId) return false;
    return true;
};

export const preferPackagesAtLocation = (packages: Package[], currentSpotId?: string | null, currentSlotId?: string | null): Package[] => {
    const atLocation = packages.filter((pkg) => matchesPackageLocation(pkg, currentSpotId, currentSlotId));
    return atLocation.length > 0 ? atLocation : packages;
};
